// // // src/components/HorizontalStepper.js
// // import React, { useContext } from 'react';
// // import { Stepper, Step, StepLabel, StepButton } from '@mui/material';
// // import { useNavigate } from 'react-router-dom';
// // import ProgressContext from '../context/ProgressContext';
// // function HorizontalStepper() {
// //   const { steps, currentStep, completedSteps, goToStep } = useContext(ProgressContext);
// //   const navigate = useNavigate();
// //   const handleStepClick = (stepIndex) => {
// //     if (completedSteps.includes(stepIndex) || stepIndex === currentStep) {
// //       navigate(steps[stepIndex].path);
// //       goToStep(stepIndex);
// //     }
// //   };
// //   return (
// //     <Stepper nonLinear activeStep={currentStep} alternativeLabel>
// //       {steps.map((step, index) => (
// //         <Step key={step.label} completed={completedSteps.includes(index)}>
// //           <StepButton onClick={() => handleStepClick(index)}>
// //             {step.label}
// //           </StepButton>
// //         </Step>
// //       ))}
// //     </Stepper>
// //   );
// // }
// // export default HorizontalStepper;

// // src/components/HorizontalStepper.js
// import React, { useContext } from 'react';
// import { Stepper, Step, StepLabel, StepButton } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import ProgressContext from '../context/ProgressContext';
// function HorizontalStepper() {
//   const { steps, currentStep, completedSteps, goToStep } = useContext(ProgressContext);
//   const navigate = useNavigate();
//   const handleStepClick = (stepIndex) => {
//     if (completedSteps.includes(stepIndex) || stepIndex === currentStep) {
//       navigate(steps[stepIndex].path);
//       goToStep(stepIndex);
//     }
//   };
//   return (
//     <Stepper nonLinear activeStep={currentStep} alternativeLabel>
//       {steps.map((step, index) => (
//         <Step key={step.label} completed={completedSteps.includes(index)}>
//           <StepButton onClick={() => handleStepClick(index)}>
//             {step.label}
//           </StepButton>
//         </Step>
//       ))}
//     </Stepper>
//   );
// }
// export default HorizontalStepper;



import React, { useContext } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProgressContext from '../context/ProgressContext';
export default function HorizontalStepper() {
  const { steps, currentStep, goToStep } = useContext(ProgressContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: isMobile ? 1 : 0,
        my: 3,
        width: '100%',
        maxWidth: 900,
        mx: 'auto',
        background: 'transparent',
      }}
    >
      {steps.map((step, idx) => {
        const isActive = idx === currentStep;
        const isClickable = idx <= currentStep;
        return (
          <Box
            key={step.label}
            onClick={() => {
              if (isClickable) {
                navigate(step.path);
                goToStep(idx);
              }
            }}
            sx={{
              flex: isMobile ? '1 1 100%' : 1,
              px: isMobile ? 2 : 2.5,
              py: isMobile ? 1.2 : 1.8,
              background: isActive
                ? 'linear-gradient(90deg, #F15A29 0%, #FDB813 100%)'
                : 'linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 100%)',
              color: isActive ? '#fff' : '#333',
              fontWeight: 600,
              fontSize: isMobile ? '0.9rem' : '1rem',
              textAlign: 'center',
              cursor: isClickable ? 'pointer' : 'default',
              userSelect: 'none',
              borderRadius: 2,
              transition: 'all 0.3s ease-in-out',
              boxShadow: isActive ? '0px 3px 8px rgba(0, 0, 0, 0.2)' : 'none',
              ...(idx !== steps.length - 1 &&
                !isMobile && {
                  clipPath:
                    'polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%)',
                }),
              ...(idx === steps.length - 1 &&
                !isMobile && {
                  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                }),
            }}
          >
            <Typography variant="body4">
              {`Step ${idx + 1} - ${step.label}`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

